<template>
    <div class="loan-table">
        <ahDataTable
            tableKey="loan-index-data-table"
            :columns="columns"
            :data="datas"
            :showRefreshButton="true"
            :indexStart="pageSize * (currPage - 1) + 1"
            v-loading="loading"
            @row-click="onClick"
            @refresh="$emit('refresh')"
        >
            <template v-slot:title="scope">
                <div>
                    <span style="font-weight: bold;">{{ scope.row.title || "--" }} </span>
                </div>
                <div><Money :v="scope.row.totalAmount" /> 元</div>
            </template>
            <template v-slot:amortizationAmount="scope">
                <div v-if="scope.row.amortizationAmount > 0">
                    <div><Money :v="scope.row.amortizationAmount" /> 元</div>
                    <el-progress
                        :percentage="getAmortizationPercentage(scope.row)"
                        :show-text="false"
                        :color="getAmortizationPercentage(scope.row) === 100 ? '#92DE56' : '#463cb2'"
                        :stroke-width="6"
                        style="margin-top: 7px; width: 80%;"
                    ></el-progress>
                    <div style="font-size: 9pt; color: #666; margin-top: 5px;">
                        <span>還款進度：</span>
                        <span style="padding: 0 0px 0 0px">{{ Math.round(getAmortizationPercentage(scope.row)) }}%</span>
                        <el-tooltip class="item" effect="dark" content="已動撥 / 已還款" placement="right">
                            <span
                                >（<Money style="font-weight: normal" :v="scope.row.statistics.amortizationDrawdownTotalAmount" /> /
                                <Money style="font-weight: normal" :v="scope.row.statistics.amortizationRepaymentTotalAmount" />）</span
                            >
                        </el-tooltip>
                    </div>
                    <div style="font-size: 9pt; color: #666; margin-top: -2px;">
                        可用額度：<Money style="font-weight: normal" :v="scope.row.amortizationAmount - scope.row.statistics.amortizationDrawdownTotalAmount" />
                    </div>
                    <div style="font-size: 9pt; color: #666; margin-top: -2px;">
                        未還金額：<Money style="font-weight: normal" :v="scope.row.amortizationAmount - scope.row.statistics.amortizationRepaymentTotalAmount" />
                    </div>
                    <div style="font-size: 9pt; color: #666; margin-top: -2px;">還款期限：{{ scope.row.amortizationEndDate | dateFormater("YYYY-MM-dd") }}</div>
                </div>
                <div v-else>
                    <div class="empty-label">(無)</div>
                </div>
            </template>
            <template v-slot:repaymentAmount="scope">
                <div v-if="scope.row.repaymentAmount > 0">
                    <div><Money :v="scope.row.repaymentAmount" /> 元</div>
                    <div style="font-size: 9pt; color: #666;">
                        <div>
                            可用額度：<Money
                                style="font-weight: normal"
                                :v="scope.row.repaymentAmount - (scope.row.statistics.revolvingDrawdownTotalAmount - scope.row.statistics.revolvingRepaymentTotalAmount)"
                            />
                        </div>
                        <div>額度到期日：{{ scope.row.repaymentEndDate | dateFormater("YYYY-MM-dd") }}</div>
                    </div>
                </div>
                <div v-else>
                    <div class="empty-label">(無)</div>
                </div>
            </template>
            <template v-slot:approvalDate="scope">
                {{ scope.row.approvalDate | dateFormater("YYYY-MM-dd") }}
            </template>
        </ahDataTable>
    </div>
</template>

<script>
import ahDataTable from '@/components/ui/ahDataTable.vue';

export default {
    components: { ahDataTable },
    props: {
        datas: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        pageSize: {
            type: Number,
            default: 25,
        },
        currPage: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            columns: {
                index: {
                    label: '#',
                },
                systemNo: {
                    label: '系統編號',
                    width: 135,
                },
                title: {
                    label: '借款名稱 / 總額度',
                    disableHide: true,
                },
                amortizationAmount: {
                    label: '平均攤還額度',
                    width: 270,
                },
                repaymentAmount: {
                    label: '循環額度',
                    width: 250,
                },
                approvalDate: {
                    label: '核准日期',
                    width: 130,
                },
            },
        };
    },
    methods: {
        onClick({ sno }) {
            this.$router.push({ name: 'loan-management-detail', params: { sno } });
        },
        getAmortizationPercentage(row) {
            const p = Math.round((row.statistics.amortizationRepaymentTotalAmount / row.statistics.amortizationDrawdownTotalAmount) * 100);
            return p || 0;
        },
        getRepaymentPercentage(row) {
            const left = row.repaymentAmount - (row.statistics.revolvingDrawdownTotalAmount - row.statistics.revolvingRepaymentTotalAmount);
            return Math.round((left / row.repaymentAmount) * 100);
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";
.loan-table {
    .progress-block > *:first-child {
        font-weight: bold;
    }
    .empty-label {
        color: #888;
    }
}
</style>
